export const upsertCustomCompletePageTheme = (
  input: string | null | undefined,
  theme: string
): string => {
  if (!theme) return '@icon[check]@theme[#51a855]@content[]'

  const iconRegex = /@icon\[[^\]]*]/
  const themeRegex = /@theme\[[^\]]*]/
  const contentRegex = /@content\[(.*?)\]/s

  const iconMatch = input?.match(iconRegex)
  const themeMatch = input?.match(themeRegex)
  const contentMatch = input?.match(contentRegex)

  const iconPart = iconMatch?.[0] ?? '@icon[check]'
  const contentPart = contentMatch?.[0] ?? ''

  if (input && themeMatch) {
    return input.replace(themeRegex, `@theme[${theme}]`)
  }

  return `${iconPart}@theme[${theme}]${contentPart}`
}
